<template>
  <div>
    <div class="loaging_block">
      <Loading />
    </div>
    <div class="loaging_block">
      <SmallLoading />
    </div>
  </div>
</template>
<script>
import Loading from '../../components/atoms/loadings/Loading.vue'
import SmallLoading from '../../components/atoms/loadings/SmallLoading.vue'
export default {
  components: { Loading, SmallLoading }
}
</script>
